import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { LoginContext } from "../AuthContext/LoginContext";

const SignInLayer = () => {
  const { login } = useContext(LoginContext);
  const [showPassword, setShowPassword] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    emailOrMobile: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginDetails({ ...loginDetails, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loginDetails.emailOrMobile === "" || loginDetails.password === "") {
      alert("Please enter details");
    } else {
      setLoading(true);
      await login(loginDetails.emailOrMobile, loginDetails.password);
      setLoading(false);
    }
  };

  return (
    <section className="auth-container">
      {/* 🔹 Video background */}
      <video
        className="auth-video"
        src="assets/images/Login-Page-Cover-Video.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Content overlay */}
      <div className="frosted-glass-card">
        <div className="card-content">
          <Link to="/" className="logo-link">
            <div className="flex items-center">
              <img
                src="assets/images/govpklogo.png"
                alt="Logo"
                className="logo-image"
                style={{ width: "120px", height: "auto" }}
              />
            </div>
          </Link>
          <h6 className="card-title">Sign In to Make Pakistan Green</h6>
          <p className="card-subtitle">
            Welcome back! please enter your detail
          </p>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-field">
              <span className="form-icon pb-3">
                <Icon icon="mage:email" />
              </span>
              <input
                type="text"
                name="emailOrMobile"
                className="form-input"
                placeholder="Email or Mobile Number"
                value={loginDetails.emailOrMobile}
                onChange={handleLoginChange}
              />
            </div>
            <div className="form-field password-field">
              <div className="form-field">
                <span className="form-icon pb-3">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-input"
                  id="your-password"
                  placeholder="Password"
                  value={loginDetails.password}
                  onChange={handleLoginChange}
                />
              </div>
              <span
                className={`toggle-password ${
                  !showPassword ? "ri-eye-close-line" : "ri-eye-line"
                }`}
                data-toggle="#your-password"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <div className="forgot-password">
              <Link to="/forgot-password" className="forgot-password-link">
                Forgot Password?
              </Link>
            </div>
            <button
              type="submit"
              className="submit-button text-center"
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Sign In"
              )}
              <div className="tutorials" style={{ marginTop: '1rem', textAlign: 'center' }}>
              <a href="https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Tutorials/PPMS_User_Manual.pdf" target="_blank" rel="noopener noreferrer" className="tutorials-link ">
                User Manual PDF
              </a>
              <span style={{ margin: '0 1rem' }}>|</span>
              <a href="https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Tutorials/PPMS%20VIdeo.mp4" target="_blank" rel="noopener noreferrer" className="tutorials-link ">
                User Manual Video
              </a>
            </div>
            </button>
          </form>
          
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
